export type SignalListener<T> = (value: T) => void;
export class Signal<T> {
	private listeners: Array<SignalListener<T>> = [];
	public send(value: T): void {
		this.listeners.forEach(handler => {
			try {
				handler(value);
			} catch (er) {
				console.error(er);
			}
		});
	}

	public listen(listener: SignalListener<T>): void {
		this.listeners.push(listener);
	}
}
